import clsx from "clsx";

import { Icon } from "../Icon";

type InfoBoxProps = {
  className?: string;
  icon?: Parameters<typeof Icon>[0]["name"];
  iconClassName?: string;
  message: string;
  title?: string;
};

export function InfoBox({
  className,
  icon = "circleExclamation",
  iconClassName,
  message,
  title,
}: InfoBoxProps) {
  return (
    <div
      className={clsx(
        "rounded-lg border border-gray-200 bg-gray-50 p-2 lg:p-4",
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <Icon
          name={icon}
          className={clsx(
            "h-4 lg:h-5 w-4 lg:w-5 mt-0.5",
            iconClassName ?? "text-orange-700",
          )}
        />
        <div>
          {title && (
            <p className="text-xs lg:text-sm font-medium text-gray-900">
              {title}
            </p>
          )}
          <p
            className={clsx(
              "text-xs lg:text-sm text-gray-700",
              title && "mt-1",
            )}
          >
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
